import React from 'react'
import { AdminProfile } from '../../../../Components/Views'
import useAuth from '../../../../Hooks/Auth'

function Profile() {
    const { editProfile } = useAuth();
    return (
        <AdminProfile editProfile={editProfile} />
    )
}

export default Profile